"use strict";
import m from 'mithril';

import imgCross from 'img/cross.svg';

import 'scss/dialog';
import 'scss/home';

export default {
    view: ({attrs}) => m(
        'section',
        {class: 'sites'},
        [
            m(
                'button',
                {
                    class: 'right request-login',
                    onclick: () => attrs.requestLoginActive = true,
                },
                'Request a Login'
            ),
            m('h1', {}, 'Sites')
        ].concat(
            attrs.requestLoginActive ?
                m('div', {class: 'mask'}) :
                null,
            !attrs.requestLoginActive ?
                null :
                m(
                    'div',
                    {class: 'dialog centred request-login'},
                    [
                        m(
                            'div',
                            {class: 'title'},
                            [
                                m(
                                    'img',
                                    {
                                        class: 'right cross',
                                        onclick: () => attrs.requestLoginActive = false,
                                        src: imgCross
                                    }
                                ),
                                m('div', {class: 'heading'}, 'Request a Login')
                            ]
                        ),
                        m(
                            'div',
                            {class: 'content'},
                            Object.entries(attrs.siteGroups)
                                .map(([siteGroup, groupDetails]) => m(
                                    'section',
                                    {class: 'site-group'},
                                    [
                                        m('h1', {}, siteGroup)
                                    ].concat(
                                        groupDetails.sites.map(s =>
                                            m(
                                                'button',
                                                {
                                                    class: 'site',
                                                    onclick: () => window.open(s.requestUrl)
                                                },
                                                s.name
                                            )
                                        )
                                    )
                                ))
                        )
                    ]
                ),
            Object.entries(attrs.siteGroups)
                .map(([siteGroup, groupDetails]) => m(
                    'section',
                    {class: 'site-group'},
                    [
                        m(
                            'button',
                            {
                                class: 'info right ' + (groupDetails.infoActive ? 'less' :'more'),
                                onclick: () => attrs.siteGroups[siteGroup].infoActive = !groupDetails.infoActive
                            },
                            (groupDetails.infoActive ? 'Less' :'More') + ' Info'
                        ),
                        m('h1', {}, siteGroup),
                        m('div', {class: 'underline'}),
                        !groupDetails.infoActive ?
                            null :
                            m(
                                'div',
                                {class: 'info-show'},
                                [
                                    groupDetails.info
                                ]
                            ),
                    ].concat(
                        groupDetails.sites.map(s => m(
                            'button',
                            {
                                class: 'site',
                                onclick: () => window.open(s.url)
                            },
                            s.name
                        ))
                    )
                ))
        )
    )
}
;